/* RESPONSIBLE TEAM: team-inbox-experience */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class DomainObjectInstanceSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    attributes: {
      embedded: 'always',
    },
  };
}
